<template>
    <div class='message-list'>
        <div v-if="isLoading || isLoadingEvents" class="has-text-centered">
            <br>
            <loader />
            Indlæser beskeder
        </div>

        <template v-else>
            <template v-for="element in content">
                <message v-if="element.contentType === 'message'" :key="element.id"
                         :message="element"
                         :sender="conversation.sender"
                         :addressee="conversation.addressee"
                         :isLast="conversation.latest_message.id === element.id" />

                <div v-else class="has-text-centered">
                    <hr />

                    <p>{{$t(`projects.events.${element.type}`)}}</p>
                    <small>{{element.created_at | formatShortDateTime}}</small>

                    <hr />
                </div>
            </template>
        </template>
    </div>
</template>

<script>
    import Loader from '@/global/components/Loader';
    import Message from '@/taskflex/conversations/components/Messages/Message';
    import { mapGetters, mapActions, mapMutations } from 'vuex';
    import { SET_MESSAGES_ON_CONVERSATION } from '@/taskflex/conversations/store/_types';
    import MessageService from '@/taskflex/conversations/services/MessageService';
    import ProjectEventsService from '@/taskflex/projects/services/ProjectEventsService';

    export default {
        data() {
            return {
                isLoadingEvents: false,
                projectEvents: [],
            };
        },

        computed: {
            ...mapGetters('conversations', {
                conversation: 'activeConversation',
                isLoading: 'isLoadingMessages',
            }),

            ...mapGetters('auth', [
                'currentUserAccount',
            ]),

            content() {
                // Get messages, map to include contentType: 'message',
                const {
                    messages: conversationMessages = [],
                } = this.conversation;

                const messages = conversationMessages.map((message) => {
                    message.contentType = 'message';
                    return message;
                });

                // Get events, filter to remove non-offer events, map to include contentType: 'event'
                const events = this.projectEvents
                    .filter(event => [
                        'project-price-offer-posted',
                        'project-price-offer-edited',
                        'project-price-offer-accepted',
                    ].includes(event.type))
                    .map((event) => {
                        event.contentType = 'event';
                        return event;
                    });


                // join the two datasets, sort by created, asc.

                return [
                    ...messages,
                    ...events,
                ].sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
            },
        },

        watch: {
            conversation() {
                this.setupList();
            },
        },

        mounted() {
            this.setupList();

            if (this.conversation.project) {
                this.loadEvents();
            }

            // join project-event-channel 'projects.ID.events'
        },

        methods: {
            loadEvents() {
                const options = {
                    includes: ['account'],

                    sort: [
                        {
                            key: 'created_at',
                            direction: 'asc',
                        },
                    ],
                };

                this.isLoadingEvents = true;

                const { project } = this.conversation;

                ProjectEventsService.findAll(project.id, options, ({ data: { rows } }) => {
                    this.isLoadingEvents = false;

                    this.projectEvents = rows;
                });
            },

            setupList() {
                window.Echo.join(`conversations.${this.conversation.id}.messages`)
                    .listen('.Taskflex\\Conversations\\Events\\MessageSentEvent', (event) => {
                        this.setMessages({
                            conversation: this.conversation,
                            messages: [event.message],
                        });

                        this.setLatestMessageRead();

                        this.$emit('change');
                    });

                if (!this.conversation.messages) {
                    this.loadMessagesForConversation(this.conversation)
                        .then(() => {
                            this.setLatestMessageRead();

                            this.$emit('change');
                        });
                }
            },

            ...mapActions('conversations', [
                'loadMessagesForConversation',
            ]),

            ...mapMutations('conversations', {
                setMessages: SET_MESSAGES_ON_CONVERSATION,
            }),

            setLatestMessageRead() {
                const {
                    id: conversationId,
                    messages,
                } = this.conversation;

                if (!messages.length) {
                    return;
                }

                const accountId = this.currentUserAccount.id;
                const latestUnreadMessages = messages
                    .filter(message => message.read_at === null && message.sender.id !== accountId)
                    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

                if (!latestUnreadMessages.length) {
                    return;
                }

                const latestUnreadMessage = latestUnreadMessages[0];

                MessageService.read(conversationId, latestUnreadMessage.id);
            },
        },

        components: {
            Loader,
            Message,
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/conversations/components/Messages/MessageList.vue